import { EXCEL_STYLES } from '../constants.js';

export const hexToBackgroundAttributes = (hex) => {
  if (!hex || !hex.split) return {};
  const hexCode = hex.split('#')[1];
  if (!hexCode) return {};
  return {
    fill: {
      type: 'pattern',
      pattern: 'solid',
      fgColor: { argb: `FF${hexCode}` }
    }
  };
};

export const hexToForegroundAttributes = (hex) => {
  if (!hex || !hex.split) return {};
  const hexCode = hex.split('#')[1];
  if (!hexCode) return {};
  return {
    font: {
      color: { argb: `FF${hexCode}` }
    }
  };
};

export const getColorStyle = (colorKey, colorMap) => {
  if (colorMap && colorMap[colorKey]) {
    return hexToBackgroundAttributes(colorMap[colorKey]);
  }
  if (EXCEL_STYLES[colorKey]) {
    return hexToBackgroundAttributes(EXCEL_STYLES[colorKey]);
  }
  return {};
};

export const createHeaderStyle = (colorMap) => {
  const headerBgColor = getColorStyle('HEADER_BG', colorMap).fill?.fgColor?.argb || EXCEL_STYLES.HEADER_BG;
  const headerBorderColor = getColorStyle('HEADER_BORDER', colorMap).fill?.fgColor?.argb || EXCEL_STYLES.HEADER_BORDER;
  
  return {
    fill: { type: 'pattern', pattern: 'solid', fgColor: { argb: headerBgColor } },
    font: { bold: true, size: 9, color: { argb: EXCEL_STYLES.BLACK_TEXT } },
    border: {
      right: { style: 'thin', color: { argb: headerBorderColor } },
      bottom: { style: 'thin', color: { argb: headerBorderColor } }
    }
  };
};

export const createAggregationCellStyle = (isGroupOrParent = false) => ({
  alignment: { horizontal: 'center', vertical: 'middle' },
  font: { bold: isGroupOrParent ? true : false, },
  fill: {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: isGroupOrParent ? 
      EXCEL_STYLES.GROUP_AGGREGATION_BG 
      : EXCEL_STYLES.AGGREGATION_BG 
    }
  }
});